import React, { cloneElement } from 'react';
import {
    Collapsible,
    CollapsibleContent,
    CollapsibleGroup,
    CollapsibleHeader,
    CollapsibleHeaderChevron,
} from '@fiverr-private/disclosure';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import SafeComponent from '../../shared/SafeComponent';
import Answer from './Answer';
import { FAQ_COPY_PREFIX, getFaqQuestions } from './config';
import { titleClass } from './styles.ve.css';

interface RenderedQuestionProps {
    key: number;
    expanded: boolean;
    onToggle: (expanded: boolean) => void;
}

const renderQuestion = (child: any, renderedProps: object, lastQuestionIndex: number) => {
    const { key, ...props } = renderedProps as RenderedQuestionProps;

    return (
        <Container
            key={key}
            borderBottomWidth="sm"
            borderStyle="solid"
            borderColor="grey_500"
            paddingBottom="5"
            marginBottom={key === lastQuestionIndex ? '0' : '5'}
        >
            {cloneElement(child, { ...props, paddingBottom: '0' })}
        </Container>
    );
};

const Faqs = () => {
    const questions = getFaqQuestions();
    const lastQuestionIndex = questions.length - 1;

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '8', md: '10' }}>
            <Stack direction={{ default: 'column', md: 'row' }} gap={{ default: '8', md: '0', lg: '16' }}>
                <Container width={{ default: '100%', md: '306px' }} flexShrink={0}>
                    <Typography as="h2" color="grey_1200" className={titleClass}>
                        <I18n k={`${FAQ_COPY_PREFIX}.title`} />
                    </Typography>
                </Container>
                <Container flexGrow={1} minWidth={0} width="100%">
                    <CollapsibleGroup
                        defaultExpandedIndex={0}
                        renderChildren={(child, renderedProps) =>
                            renderQuestion(child, renderedProps, lastQuestionIndex)
                        }
                    >
                        {questions.map(({ key, links }) => (
                            <Collapsible key={key}>
                                <CollapsibleHeader paddingY="0" fontSize="b_lg" lineHeight="h_xs" color="grey_1200">
                                    <Typography as="span" fontWeight="bold" fontSize="b_lg" lineHeight="h_xs">
                                        <I18n k={`${FAQ_COPY_PREFIX}.questions.${key}.question`} />
                                    </Typography>
                                    <CollapsibleHeaderChevron variant="lean" />
                                </CollapsibleHeader>
                                <CollapsibleContent paddingTop="2" paddingRight="9">
                                    <Answer answerKey={`${FAQ_COPY_PREFIX}.questions.${key}.answer`} links={links} />
                                </CollapsibleContent>
                            </Collapsible>
                        ))}
                    </CollapsibleGroup>
                </Container>
            </Stack>
        </Section>
    );
};

export { Faqs };
export default SafeComponent(Faqs);
